import { useEffect } from "react";
import { Navigate } from "react-router";

import { useDispatch } from "common/utilities/react-redux";
import { activateModal } from "domains/modal/actions";

export const WhatsNewRoute = () => {
  const dispatch = useDispatch();
  useEffect(() => void dispatch(activateModal({ id: "WhatsNew" })), [dispatch]);
  return <Navigate to="/" replace />;
};
